const urls = {
  logSubscription() {
    return `/odin/operator-app/log-event`;
  },
  saveSubscription() {
    return `https://script.google.com/macros/s/AKfycby2u1KB8Q6jrVuEevbeMDDcPdXGVftdftLhtJTS0BvtHfg4VRRHxeg8yOY528GfjbeXNQ/exec`;
  },
  getWalletBalance() {
    return `/rest/tesseract/v1/payment/wallet`;
  },
  initiatePaymentRecharge() {
    return `rest/tesseract/v1/payment/wallet/initiate-recharge`;
  },
  completePaymentRecharge() {
    return `rest/tesseract/v1/payment/wallet/complete-recharge`;
  },
  subscribe() {
    return `/rest/tesseract/v1/profile/subscribe`;
  },
};

export default urls;
